const getTipsPickupPosition = (state) => state.headState.tipsPickupPosition;

const getTipsPickupLastCalibratedDate = (state) => state.headState.tipsPickupLastCalibrationDate;

const getTipsPickupIsRecentlyCalibrated = (state) => state.headState.tipsPickupLastCalibratedDate;

// eslint-disable-next-line import/prefer-default-export
export const TipsPickupSelectors = {
  getPosition: getTipsPickupPosition,
  getLastCalibratedDate: getTipsPickupLastCalibratedDate,
  getIsRecentlyCalibrated: getTipsPickupIsRecentlyCalibrated,
};
